(function () {
  'use strict';

  var REQUIRED_SOURCE = 'points_mall';
  var REQUIRED_ACTION = 'view';
  var TOTAL_SECONDS = 15;
  var AWARD_POINTS = 30;
  var AWARD_IMAGE = 'https://cdn.shopify.com/s/files/1/2234/5357/files/Group_487_2x_d06c3e89-97b3-4b07-aba1-58c4935de9ad.png?v=1778486231';
  var COMPLETE_ENDPOINT = 'https://www.kemimoto.com/apps/kemimoto-proxy/api/points/task/user/complete';
  var MALL_URL = '/pages/points-mall';
  var params = new URLSearchParams(window.location.search);
  var source = params.get('source') || params.get('page_source') || params.get('from');
  var action = params.get('action');
  var taskCode = params.get('code') || '';

  if (source !== REQUIRED_SOURCE || action !== REQUIRED_ACTION || !taskCode) return;

  var remainingSeconds = TOTAL_SECONDS;
  var animationFrame = null;
  var lastFrameAt = 0;
  var elapsedVisibleMs = 0;
  var hasStarted = false;
  var hasCompleted = false;
  var indicator = null;
  var timeEl = null;

  function appendStyle(id, rules) {
    if (document.getElementById(id)) return;

    var style = document.createElement('style');
    style.id = id;
    style.textContent = rules.join('');
    document.head.appendChild(style);
  }

  function injectTrackerStyles() {
    appendStyle('points-view-task-tracker-style', [
      '.points-view-task-tracker {',
      '  position: fixed;',
      '  top: max(20vh, env(safe-area-inset-top));',
      '  right: 8px;',
      '  z-index: 10050;',
      '  width: 54px;',
      '  height: 54px;',
      '  border-radius: 50%;',
      '  background: conic-gradient(#e4002b var(--points-view-progress, 0deg), rgba(228,0,43,0.16) 0deg);',
      '  box-shadow: 0 6px 18px rgba(0,0,0,0.18);',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  pointer-events: none;',
      '}',
      '.points-view-task-tracker::before {',
      '  content: "";',
      '  position: absolute;',
      '  inset: 5px;',
      '  border-radius: 50%;',
      '  background: #fff;',
      '}',
      '.points-view-task-tracker__time {',
      '  position: relative;',
      '  z-index: 1;',
      '  color: #111;',
      '  font-size: 16px;',
      '  line-height: 1;',
      '  font-weight: 800;',
      '}'
    ]);
  }

  function injectCompletionStyles() {
    appendStyle('points-view-complete-modal-style', [
      '.points-view-complete-modal {',
      '  position: fixed;',
      '  inset: 0;',
      '  z-index: 10090;',
      '  display: none;',
      '}',
      '.points-view-complete-modal.is-active {',
      '  display: block;',
      '}',
      '.points-view-complete-modal__mask {',
      '  position: absolute;',
      '  inset: 0;',
      '  background: rgba(0,0,0,0.86);',
      '}',
      '.points-view-complete-modal__dialog {',
      '  position: absolute;',
      '  left: 50%;',
      '  top: 50%;',
      '  width: min(298px, calc(100vw - 24px));',
      '  min-height: 240px;',
      '  padding: 24px 16px 10px;',
      '  border-radius: 8px;',
      '  background: #fff;',
      '  color: #111;',
      '  text-align: center;',
      '  transform: translate(-50%, -50%);',
      '}',
      '.points-view-complete-modal__title {',
      '  position: relative;',
      '  display: inline-block;',
      '  margin: 0 0 24px;',
      '  font-size: 20px;',
      '  line-height: 1.2;',
      '  font-weight: 800;',
      '}',
      '.points-view-complete-modal__title::after {',
      '  content: "";',
      '  position: absolute;',
      '  left: 50%;',
      '  bottom: -7px;',
      '  width: 45px;',
      '  height: 5px;',
      '  background: #e4002b;',
      '  border-radius: 999px;',
      '  transform: translateX(-50%) skewX(-18deg);',
      '}',
      '.points-view-complete-modal__coin-wrap {',
      '  width: 84px;',
      '  height: 84px;',
      '  margin: 0 auto 6px;',
      '  border-radius: 50%;',
      '  background: #f8f8f8;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '}',
      '.points-view-complete-modal__coin {',
      '  width: 70px;',
      '  height: 70px;',
      '  object-fit: contain;',
      '}',
      '.points-view-complete-modal__points {',
      '  margin: 0 0 18px;',
      '  color: #222;',
      '  font-size: 16px;',
      '  line-height: 1.25;',
      '}',
      '.points-view-complete-modal__btn {',
      '  min-width: 132px;',
      '  height: 38px;',
      '  border: 0;',
      '  border-radius: 999px;',
      '  background: linear-gradient(270deg, #e4002b 0%, #ff3158 100%);',
      '  color: #fff;',
      '  font-size: 14px;',
      '  font-weight: 800;',
      '  cursor: pointer;',
      '}'
    ]);
  }

  function updateIndicator(progressSeconds) {
    if (!indicator || !timeEl) return;

    var displaySeconds = Math.ceil(progressSeconds);
    var progress = Math.min(1, Math.max(0, progressSeconds / TOTAL_SECONDS));
    indicator.style.setProperty('--points-view-progress', Math.round(progress * 360) + 'deg');
    timeEl.textContent = displaySeconds + 's';
  }

  function createIndicator() {
    injectTrackerStyles();

    indicator = document.createElement('div');
    indicator.className = 'points-view-task-tracker';
    indicator.setAttribute('aria-live', 'polite');

    timeEl = document.createElement('span');
    timeEl.className = 'points-view-task-tracker__time';
    indicator.appendChild(timeEl);

    document.body.appendChild(indicator);
    updateIndicator(remainingSeconds);
  }

  function getCompletionDetail() {
    return {
      source: source,
      action: action,
      taskId: params.get('id') || '',
      duration: TOTAL_SECONDS,
      points: AWARD_POINTS
    };
  }

  function grantGoalPoints() {
    var detail = getCompletionDetail();
    var awardPromise = typeof window.pointsViewTaskAwardPoints === 'function'
      ? Promise.resolve(window.pointsViewTaskAwardPoints(detail))
      : Promise.resolve({ mocked: true });

    return awardPromise.then(function (awardResponse) {
      detail.awardResponse = awardResponse;
      window.dispatchEvent(new CustomEvent('points:view-task-complete', { detail: detail }));
      return detail;
    });
  }

  function createCompletionModal() {
    var existing = document.getElementById('points-view-complete-modal');
    if (existing) return existing;

    var modal = document.createElement('div');
    modal.className = 'points-view-complete-modal';
    modal.id = 'points-view-complete-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = [
      '<div class="points-view-complete-modal__mask"></div>',
      '<div class="points-view-complete-modal__dialog" role="dialog" aria-modal="true" aria-label="Completed">',
      '  <h3 class="points-view-complete-modal__title">Completed!</h3>',
      '  <div class="points-view-complete-modal__coin-wrap">',
      '    <img class="points-view-complete-modal__coin" src="' + AWARD_IMAGE + '" alt="' + AWARD_POINTS + ' Goal Points">',
      '  </div>',
      '  <p class="points-view-complete-modal__points">Task completed successfully.</p>',
      '  <button class="points-view-complete-modal__btn" type="button">Confirm</button>',
      '</div>'
    ].join('');

    modal.addEventListener('click', function (event) {
      if (event.target.classList.contains('points-view-complete-modal__btn')) {
        goToPointsMall();
      }
    });

    document.body.appendChild(modal);
    return modal;
  }

  function showCompletionModal() {
    injectCompletionStyles();
    if (indicator) indicator.remove();

    var modal = createCompletionModal();
    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function goToPointsMall() {
    window.location.href = MALL_URL;
  }

  function closeCompletionModal() {
    var modal = document.getElementById('points-view-complete-modal');
    if (!modal) return;
    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function callCompleteApi() {
    return fetch(COMPLETE_ENDPOINT, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        taskCode: taskCode,
        userId: (window.SHOPIFY_CUSTOMER && window.SHOPIFY_CUSTOMER.id)
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HTTP error! status: ' + response.status);
      }
      return response.json();
    }).then(function (payload) {
      if (Number(payload && payload.code) !== 200) {
        var error = new Error((payload && payload.msg) || 'Failed to complete task.');
        error.payload = payload;
        throw error;
      }
      return payload;
    });
  }

  function completeTask() {
    if (hasCompleted) return;
    hasCompleted = true;
    stopTimer();
    updateIndicator(0);
    showCompletionModal();

    callCompleteApi()
      .catch(function (error) {
        console.error('Failed to complete view task:', error);
        if (window.pointsShowApiError) {
          window.pointsShowApiError(error, 'Failed to complete task.');
        }
      });
  }

  function startTimer() {
    if (animationFrame || hasCompleted) return;
    lastFrameAt = performance.now();
    animateProgress();
  }

  function stopTimer() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  }

  function animateProgress() {
    if (!hasStarted || hasCompleted) return;

    var now = performance.now();
    if (!document.hidden) {
      elapsedVisibleMs += now - lastFrameAt;
    }
    lastFrameAt = now;

    var smoothRemainingSeconds = Math.max(0, TOTAL_SECONDS - (elapsedVisibleMs / 1000));
    remainingSeconds = Math.ceil(smoothRemainingSeconds);
    updateIndicator(smoothRemainingSeconds);

    if (smoothRemainingSeconds <= 0) {
      completeTask();
      return;
    }

    animationFrame = window.requestAnimationFrame(animateProgress);
  }

  function init() {
    createIndicator();
    hasStarted = true;
    startTimer();
  }

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
